export default __webpack_public_path__ + "static/media/stan-lee.11b5bc20.png";